import React from "react";
import HeroImg from "../images/myImg.jpg";
import Typed from "react-typed";
import { AiOutlineGithub } from "react-icons/ai";
import { BsLinkedin } from "react-icons/bs";
import { MdMail } from "react-icons/md";

const Hero = () => {
  return (
    <div name="hero" className="w-full md:h-screen text-white">
      <div className="h-full max-w-screen-xl  justify-center items-center mx-auto flex flex-col md:flex-row ">
        <div className="flex flex-col w-full justify-center items-center md:items-start md:mr-18 md:pl-16 mb-8 md:mb-20">
          <p className="md:mt-12 text-3xl ">Hi, I'm</p>
          <h1 className="font-rubik font-semibold text-4xl  md:text-5xl py-2">
            Vaurn Doshi
          </h1>
          <p className="font-barlow md:text-6xl text-4xl font-bold mt-2 text-[#30BCED]">
            <Typed
              strings={[
                "Blockchain Developer",
                "Backend Engineer",
                "Security Researcher",
              ]}
              typeSpeed={60}
              backSpeed={40}
              loop
            />
          </p>
          <div className="text-[#FC5130] flex flex-row j pt-8 w-40 justify-between mx-auto md:hidden mb-8 md:mb-0">
            <a href="https://github.com/varun-doshi">
              <AiOutlineGithub size={30} className="hover:scale-105" />
            </a>
            <a href="https://www.linkedin.com/in/varunxdoshi/">
              <BsLinkedin size={30} className="hover:scale-105" />
            </a>
            <a href="mailto:doshivarun202@gmail.com">
              <MdMail size={30} className="hover:scale-105" />
            </a>
          </div>
          <a
            className="border-white border-2 text-xl px-4 py-2 md:mt-8 font-poppins resumeBtn hover:text-black hover:font-light"
            href="/Varun_Doshi-Resume.pdf"
            download={true}
          >
            Resume
          </a>
        </div>
        <div className="w-full md:ml-20">
          <img
            className="rounded-full mb-8 md:mb-0 mx-auto w-[12rem] md:w-[30rem] "
            src={HeroImg}
            alt="/"
          />
        </div>
      </div>
    </div>
  );
};

export default Hero;
